export default __webpack_public_path__ + "static/media/excel-green.f0aeb877.svg";